import { render, staticRenderFns } from "./NavigationBox.vue?vue&type=template&id=7c88fbac&scoped=true&"
import script from "./NavigationBox.vue?vue&type=script&lang=js&"
export * from "./NavigationBox.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBox.vue?vue&type=style&index=0&id=7c88fbac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c88fbac",
  null
  
)

export default component.exports